export const DEFAULT_LANGUAGE_CODE = "nb-NO"

/**
 * v2-console URL search param holding a layer FeatureCode to preview on the
 * map, even when the layer is still disabled (pending backoffice review).
 * Shared here because the backoffice review queue builds hot-links with it
 * and the console reads it.
 */
export const MAP_LAYER_PREVIEW_URL_PARAM = "previewLayer"

/** Norway's IANA time zone: the day boundary for Norwegian dates (legal billing and summaries). */
export const NORWAY_TIME_ZONE = "Europe/Oslo"
